<template>
  <v-menu
    :disabled="!hasItems"
    :offset-y="!isSubmenu"
    :offset-x="isSubmenu"
    :open-on-hover="isSubmenu"
  >
    <template #activator="{ on, attrs }">
      <deck-tabs-tab
        v-bind="attrs"
        :to="localePath(item.to)"
        :exact="true"
        :text="item.title"
        class="public-topbar-page-button"
        :class="{ 'public-topbar-page-button--menu': isSubmenu }"
        v-on="on"
      >
        <template v-if="isGroup" #append-tab>
          <deck-icon
            size="small"
            name="chevron-down"
            color="grey"
          />
        </template>
      </deck-tabs-tab>
    </template>
    <v-list
      v-if="hasItems"
      class="public-topbar-page-button__submenu"
      @click.stop.prevent
    >
      <v-list-item
        v-for="(groupItem, index) in item.items"
        :key="index"
        dense
      >
        <PublicTopbarPageButton
          :item="groupItem"
          is-submenu
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import DeckTabsTab from '~/deck/tabs/tab';
import DeckIcon from '~/deck/icon';

export default {
  name: 'PublicTopbarPageButton',
  components: {
    DeckTabsTab,
    DeckIcon,
  },
  props: {
    item: { type: Object, default: () => ({}) },
    isSubmenu: { type: Boolean, default: false },
  },
  computed: {
    isGroup() {
      return (this.item.to === undefined) && (this.item.items !== undefined);
    },
    hasItems() {
      return this.item.items?.length > 0;
    },
  },
};
</script>

<style lang="scss">
.public-topbar-page-button--menu {
  width: 100%;
  height: 100%;
}

.public-topbar-page-button__submenu {
  padding: 0;

  .v-list-item {
    padding: 0;
    height: 52px;
  }
}
</style>
